import { WealthPlanWidget } from "../wealth-plan-widget";

type GlobalWealthPlanProps = {
  instanceId: string;
  currency: string;
  isDisabled: boolean;
  config: Record<string, unknown>;
};

export function GlobalWealthPlan({
  instanceId,
  currency,
  isDisabled,
  config,
}: GlobalWealthPlanProps) {
  return (
    <WealthPlanWidget
      flowInstanceId={instanceId}
      currency={currency}
      defaultPeriodYears={10}
      disabled={isDisabled}
      style={config.style as "none" | "border" | "box" | undefined}
      title={config.title as string | undefined}
      description={config.description as string | undefined}
    />
  );
}
